import hammer from '../libs/hammer'
import anime from '../libs/anime'

class Module17Slider {
  constructor() {
    let cache = {};
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
      cache.sliders = document.querySelectorAll('.module-17_slider .slider');
    };

    let registerEvents = () => {
      for (let i = 0; i < cache.sliders.length; i++) {
        cache.sliders[i].querySelector('.arrow_left').addEventListener("click", function(){ slideLeft(cache.sliders[i]) });
        cache.sliders[i].querySelector('.arrow_right').addEventListener("click", function(){ slideRight(cache.sliders[i]) });
        const bullet = cache.sliders[i].querySelectorAll('.bullet-nav .bullet');
        for (let ii = 0; ii < bullet.length; ii++) {
            bullet[ii].addEventListener("click", function(){ slideBullet(cache.sliders[i], bullet[ii]) });
        }
        let hammertime = new Hammer(cache.sliders[i]);
        hammertime.on('swipe', function(ev) {
            if(ev.direction == 2) {
                slideRight(cache.sliders[i]);
            }
            if(ev.direction == 4) {
                slideLeft(cache.sliders[i]);
            }
        });
      }

    };

    let slideLeft = function(slider) {
        let index = parseInt(slider.dataset.index);
        const bullets = slider.querySelectorAll('.bullet-nav .bullet');
        const slideContent = slider.querySelectorAll('.content_slider .slide_content');
        const slideImg = slider.querySelectorAll('.img_container .slide_img');
        const currentBullet = bullets[index];
        const currentContent = slideContent[index];
        const currentImg = slideImg[index];
        const nav = slider.querySelector('.slider-nav');
        nav.style.pointerEvents = "none";

        currentBullet.classList.remove('active');
        anime({
            targets: currentContent,
            duration: 600,
            scale: [1, 0.95],
            opacity: [1, 0],
            easing: 'easeInOutCubic',
            complete: function() {
                currentContent.style.display = "none";
            }
        });
        anime({
            targets: currentImg,
            duration: 600,
            opacity: [1, 0],
            easing: 'easeInOutCubic',
            complete: function() {
                currentImg.style.display = "none";
                nav.style.pointerEvents = "all";
            }
        });

        if(index > 0) {
            index--;
        } else {
            index = slideImg.length-1;
        }
        slider.dataset.index = index;

        const targetBullet = bullets[index];
        const targetContent = slideContent[index];
        const targetImg = slideImg[index];

        targetBullet.classList.add('active');
        targetContent.style.display = "block";
        anime({
            targets: targetContent,
            duration: 600,
            scale: [0.95, 1],
            opacity: [0, 1],
            easing: 'easeInOutCubic',
        });

        targetImg.style.display = "block";
        anime({
            targets: targetImg,
            duration: 600,
            opacity: [0, 1],
            easing: 'easeInOutCubic',
        });
    }

    let slideRight = function(slider) {
        let index = parseInt(slider.dataset.index);
        const bullets = slider.querySelectorAll('.bullet-nav .bullet');
        const slideContent = slider.querySelectorAll('.content_slider .slide_content');
        const slideImg = slider.querySelectorAll('.img_container .slide_img');
        const currentBullet = bullets[index];
        const currentContent = slideContent[index];
        const currentImg = slideImg[index];
        const nav = slider.querySelector('.slider-nav');
        nav.style.pointerEvents = "none";

        currentBullet.classList.remove('active');
        anime({
            targets: currentContent,
            duration: 600,
            scale: [1, 0.95],
            opacity: [1, 0],
            easing: 'easeInOutCubic',
            complete: function() {
                currentContent.style.display = "none";
            }
        });
        anime({
            targets: currentImg,
            duration: 600,
            opacity: [1, 0],
            easing: 'easeInOutCubic',
            complete: function() {
                currentImg.style.display = "none";
                nav.style.pointerEvents = "all";
            }
        });

        if(index < slideImg.length-1) {
            index++;
        } else {
            index = 0;
        }
        slider.dataset.index = index;

        const targetBullet = bullets[index];
        const targetContent = slideContent[index];
        const targetImg = slideImg[index];

        targetBullet.classList.add('active');
        targetContent.style.display = "block";
        anime({
            targets: targetContent,
            duration: 600,
            scale: [0.95, 1],
            opacity: [0, 1],
            easing: 'easeInOutCubic',
        });

        targetImg.style.display = "block";
        anime({
            targets: targetImg,
            duration: 600,
            opacity: [0, 1],
            easing: 'easeInOutCubic',
        });
    }

    let slideBullet = function(slider, bullet) {
        let index = parseInt(slider.dataset.index);
        const bullets = slider.querySelectorAll('.bullet-nav .bullet');
        const slideContent = slider.querySelectorAll('.content_slider .slide_content');
        const slideImg = slider.querySelectorAll('.img_container .slide_img');
        const currentBullet = bullets[index];
        const currentContent = slideContent[index];
        const currentImg = slideImg[index];
        const nav = slider.querySelector('.slider-nav');
        nav.style.pointerEvents = "none";

        currentBullet.classList.remove('active');
        anime({
            targets: currentContent,
            duration: 600,
            scale: [1, 0.95],
            opacity: [1, 0],
            easing: 'easeInOutCubic',
            complete: function() {
                currentContent.style.display = "none";
            }
        });
        anime({
            targets: currentImg,
            duration: 600,
            opacity: [1, 0],
            easing: 'easeInOutCubic',
            complete: function() {
                currentImg.style.display = "none";
                nav.style.pointerEvents = "all";
            }
        });

        index = parseInt(bullet.dataset.slide);
        slider.dataset.index = index;

        const targetBullet = bullets[index];
        const targetContent = slideContent[index];
        const targetImg = slideImg[index];

        targetBullet.classList.add('active');
        targetContent.style.display = "block";
        anime({
            targets: targetContent,
            duration: 600,
            scale: [0.95, 1],
            opacity: [0, 1],
            easing: 'easeInOutCubic',
        });

        targetImg.style.display = "block";
        anime({
            targets: targetImg,
            duration: 600,
            opacity: [0, 1],
            easing: 'easeInOutCubic',
        });
    }

    initFunc();
  };
}
export { Module17Slider }
